import { useSession } from '@/services/providers/session-provider.tsx';
import {
  hasPermission,
  hasPermissions,
  Permissions,
} from '@/features/users/schemas/users.permissions.ts';

export const usePermission = <Resource extends keyof Permissions>({
  resource,
  action,
}: {
  resource: Resource;
  action: Permissions[Resource]['action'];
}) => {
  const { userId, role } = useSession();

  return hasPermission({ userId, role }, resource, action);
};

export const usePermissions = <Resource extends keyof Permissions>(
  checks: Array<
    | [Resource, Permissions[Resource]['action']]
    | [Resource, Permissions[Resource]['action'], Permissions[Resource]['dataType']]
  >
) => {
  const { userId, role } = useSession();

  return hasPermissions({ userId, role }, checks);
};
